<script>
import PrimeButton from 'primevue/button';
import BaseVolanInput from './BaseVolanInput';
export default {
  name: 'VolanBtn',
  components: {PrimeButton},
  extends: BaseVolanInput,
  inheritAttrs: true,
  props: {
  },
  data() {
    return {

    };
  },
  computed: {
  },
};
</script>

<template>
  <PrimeButton v-bind="$attrs"
               v-on="$listeners"
  >
    <template v-for="(_, name) in $scopedSlots"
              :slot="name"
              slot-scope="slotData"
    >
      <slot :name="name"
            v-bind="slotData"
      />
    </template>
    <slot v-for="(_, name) in $slots"
          :slot="name"
          :name="name"
    />
  </PrimeButton>
</template>